import axios from 'axios';
import { IAddressCreateProps } from 'services/AddressService/types';
import { IAddressViaCepProps } from './types';

const normalizeViaCepToAddressCreate = (
  data: IAddressViaCepProps,
  postalCode: string,
): IAddressCreateProps => {
  return {
    complement: '',
    country: '',
    name: '',
    city: data.localidade,
    street: data.logradouro,
    state: data.uf,
    neighborhood: data.bairro || '',
    addrNumber: '',
    postalCode,
  };
};

export const getViaCepAdressAsync = async (
  postalCode: string,
): Promise<IAddressCreateProps> => {
  return await axios
    .get<IAddressViaCepProps>(`https://viacep.com.br/ws/${postalCode}/json/`)
    .then((response) => {
      return normalizeViaCepToAddressCreate(response.data, postalCode);
    })
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
